import React, { FC } from 'react';
import ComponentEntregador from '../editar/Component';
import { useEntregadorAdicionar } from './hooks/useEntregadorAdicionar';

const PageEditarEntregador: FC = () => {
    const oProps = useEntregadorAdicionar();
    return <ComponentEntregador {...oProps} />;
};
export default PageEditarEntregador;
